<button
  class="btn flex items-center justify-center"
  [ngClass]="buttonClassName"
  [type]="buttonType"
  [disabled]="buttonDisabled"
  (click)="clickEvent(buttonType)"
  [style.min-width.px]="btnMinWidth"
  [style.height]="btnHeight"
  [disabled]="isBtnDisabled"
>
  <img
    [style.width]="buttonIconWidth"
    src="https://cdn.catexpert.ab-inbev.com/assets/images/{{ buttonIcon }}"
    *ngIf="buttonIcon && !loaderEnabledFlag"
    class="mr-2"
  />
  <mat-spinner
    *ngIf="loaderEnabledFlag"
    class="example-margin mr-2"
    color="primary"
    mode="indeterminate"
    value="100"
    strokeWidth="2"
    diameter="20"
  >
  </mat-spinner>
  {{ buttonCaption }}
</button>
